
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Gemini-projekt',
	'appExit': 'Gå till välkomstsidan',


	'widgetsListLabel': 'Widgetlista. Välj en widget och tryck på Enter för att lägga till den.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Aktuellt',
	'dirty': 'Ej aktuellt',
	'conflict': 'Konflikt när vyn sparades',
	'error': 'Problem när vyn sparades',
	'failure': 'Det går inte att kontakta servern',
	'saveFailed': 'Det går inte att spara vyn',

	'wa_insync': 'Sparades',
	'wa_conflict': 'Konflikt när vyn sparades',
	'wa_error': 'Det går inte att spara vyn',
	'wa_failure': 'Det går inte att kontakta servern',

	// Menu Labels
	'changeDisplay': 'Ändra visning',
	'changeToColumnChart': 'Ändra till kolumndiagram',
	'changeToBubbleChart': 'Ändra till bubbeldiagram',
	'toggleMoveHandles': 'Växla flyttningshandtag',
	'undo': 'Ångra',
	'redo': 'Gör om',
	'mode': 'Ändra läge',

	'untitled': 'Namnlös',
	'remove': 'Ta bort',
	'editTitle': 'Ändra titel',
	'edit': 'Ändra',
	'done': 'Klart',

	// Data tray
	'dataTrayHandleOpenLabel': 'Öppna databehållare',
	'dataTrayHandleCloseLabel': 'Stäng databehållare',

	// Dialogs
	'dlg_loading': 'Läser in...',
	'dlg_ok': 'OK',
	'dlg_create': 'Skapa',
	'dlg_cancel': 'Avbryt',
	'dlg_close': 'Stäng',
	'dlg_update': 'Uppdatera',
	'dlg_renameBoardTitle': 'Byt namn på objektet',
	'dlg_renameDatasetTitle': 'Byt namn på datamängden',
	'dlg_renameSceneTitle': 'Byt namn på scenen',
	'dlg_NameLabel': 'Namn:',
	'dlg_NewNameLabel': 'Nytt namn:',
	'dlg_DefaultNameWithDataSet': '%{name}-vy',
	'dlg_ShareTitle': 'Dela innehåll',
	'dlg_UnshareTitle': 'Sluta dela innehåll',
	'dlg_ShareUser': 'Användar-ID:',
	'dlg_NewColumnLabel': 'Nytt beräkningsnamn',

	'dlg_new': 'Ny...',
	'dlg_open': 'Öppna...',
	'dlg_makeACopy': 'Gör en kopia',
	'dlg_rename': 'Byt namn...',
	'dlg_moreToCome': 'Fler åtgärder...',

	'dlg_use': 'Använd',

	'dlg_RelinkDatasetTitle': 'Ersätt datamängden \'%{datasetName}\' med...',

	'open_error': 'Öppningsfel för vy.',

	// Delete Board
	'del_dialogTitle': 'Bekräfta borttagning',
	'del_itemMsg': 'Vill du ta bort \'%{name}\'?',
	'del_itemsMsg': 'Är du säker på att du vill ta bort %{count} objekt?',
	'del_deleteErr': 'Det går inte att ta bort %{name}',

	// List Sorting
	'dlg_ascending': 'stigande',
	'dlg_descending': 'fallande',
	'dlg_custom': 'anpassat',
	'dlg_none': 'ingen',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Sök',

	'searchHint': 'Sök i alla data',
	'clearSearchResult': 'Rensa sökresultat',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Cirkel',
	'shapesHexagon': 'Hexagon',
	'shapesLine': 'Linje',
	'shapesOctagon': 'Oktagon',
	'shapesPentagon': 'Pentagon',
	'shapesSquare': 'Kvadrat',
	'shapesTriangle': 'Triangel',
	'shapesDiamond': 'Romb',
	'shapesTitle': 'Formegenskaper', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Rundad kvadrat',
	'shapesStar': 'Stjärna',
	'shapesChevron': 'Vinkel',
	'shapesBadge_ribbon': 'Band',
	'shapesBadge': 'Bricka',
	'shapesHeart': 'Hjärta',
	'shapesExclamation': 'Utropstecken',
	'shapesTrendingup': 'Uppåtgående trend',
	'shapesTrendingdown': 'Nedåtgående trend',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Personer',
	'shapesFemale': 'Kvinnlig',
	'shapesHappyface': 'Glad',
	'shapesMale': 'Manlig',
	'shapesMan': 'Man',
	'shapesNeutralface': 'Neutral',
	'shapesSadface': 'Ledsen',
	'shapesShakehands': 'Handskakning',
	'shapesThumbsdown': 'Tumme ned',
	'shapesThumbsup': 'Tumme upp',
	'shapesWoman': 'Kvinna',

	// Weather and places
	'shapesPlacesWeatherCat': 'Platser/väder',
	'shapesCity': 'Stad',
	'shapesCloud': 'Moln',
	'shapesEducation': 'Utbildning',
	'shapesGovernment': 'Regering',
	'shapesHalfcloud': 'Halvt moln',
	'shapesHouse': 'Hus',
	'shapesMoon': 'Måne',
	'shapesRain': 'Regn',
	'shapesSunny': 'Soligt',

	//Vehicles
	'shapesVehiclesCat': 'Fordon',
	'shapesAirplane': 'Flygplan',
	'shapesCar': 'Bil',
	'shapesShip': 'Fartyg',
	'shapesShoppingcart': 'Varukorg',
	'shapesTrain': 'Tåg',
	'shapesTruck': 'Lastbil',

	//Objects
	'shapesObjectsCat': 'Objekt',
	'shapesBook': 'Bok',
	'shapesBriefcase': 'Portfölj',
	'shapesCalendar': 'Kalender',
	'shapesCheck': 'Bock',
	'shapesClock': 'Klocka',
	'shapesDesktop': 'Skrivbord',
	'shapesDocument': 'Dokument',

	'shapesFood': 'Mat',
	'shapesGear': 'Kugghjul',
	'shapesHealth': 'Hälsa',

	'shapesIdea': 'Idé',
	'shapesMobile': 'Mobil',
	'shapesMoney_bill': 'Sedel',
	'shapesMoney_coin': 'Mynt',
	'shapesPiggybank': 'Spargris',
	'shapesStackofpaper': 'Pappershög',
	'shapesStickynote1': 'Post-it 1',
	'shapesStickynote2': 'Post-it 2',
	'shapesTarget': 'Mål',
	'shapesTool': 'Verktyg',

	'shapesUmbrella': 'Paraply',

	'shapesBrain': 'Hjärna',
	'shapesSkull': 'Skalle',
	'shapesEye': 'Öga',

	// Arrows shapes
	'shapesArrowsCat': 'Pilar',
	'shapesRightArrow': 'Högerpil',
	'shapesLeftArrow': 'Vänsterpil',
	'shapesDoubleArrow': 'Dubbelpil',
	'shapesCurvedArrow': 'Böjd pil',

	// Callouts shapes
	'shapesCalloutsCat': 'Förklaringar',
	'shapesRectCallout': 'Förklaring',

	// Images
	'imagesCat': 'Bilder',
	'imageWidgetTitle': 'Bildwidget',
	'imgUrl': 'Bild-URL',
	'noImgSelected': 'Ingen bild vald',
	'enterImgUrl': 'Ange bild-URL här',
	'imgPasteLink': 'Klistra in URL-adressen och tryck på Enter så sparas den.',
	'imgResizeToFit': 'Anpassa till bildstorlek',
	'imgHeight': 'Höjd:',
	'imgWidth': 'Bredd:',
	'imgTransparency': 'Transparens:',
	'imgMissingUrl': 'Bild-URL saknas.',
	'imgUrlValidationError': 'Ogiltig bild-URL.',
	'imgUrlInvalidDomainError': 'Bildadressen pekar på en domän som inte har godkänts av administratören. De domäner som har godkänts av administratören är "%{domains}".',

	// line shape
	'propStrokeWidth': 'Linjetjocklek',
	'propStrokeDashArray': 'Linjeformat',
	'propStrokeSolidline': 'Heldragen linje',
	'propStrokeLineCap': 'Linjeslut',
	'propStrokeLineCapButt': '"Butt"',
	'propStrokeLineCapRound': 'Avrundad',
	'propStrokeLineCapSquare': 'Kvadrat',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Spela upp',
	'dataPlayerValueListLabel': 'Datauppspelningsvärden',
	// Text Widget
	'textWidgetTitle': 'Textwidget',
	'textStyle': 'Format',
	'textStyleDescription': 'Färdiga textformat',
	'textTitleStyle': 'Rubrik',
	'textTitleSmallStyle': 'Liten rubrik',
	'textSubtitleStyle': 'Underrubrik',
	'textBodyStyle': 'Brödtext',
	'textBodySmallStyle': 'Liten brödtext',
	'textCaptionStyle': 'Objekttext',
	'textQuoteStyle': 'Citat',
	'textQuoteSmallStyle': 'Litet citat',
	'textResponsiveStyle': 'Automatisk storlek',
	'textAutoFontSize': 'Auto',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hårfin',
	'textFontFamilySubClassThin': 'Tunn',
	'textFontFamilySubClassThinItalic': 'Tunn kursiv',
	'textFontFamilySubClassExtraLight': 'Extrasmal',
	'textFontFamilySubClassExtraLightItalic': 'Extrasmal kursiv',
	'textFontFamilySubClassLight': 'Ljust',
	'textFontFamilySubClassLightItalic': 'Smal kursiv',
	'textFontFamilySubClassRegular': 'Normal',
	'textFontFamilySubClassRegularItalic': 'Normal kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Medel',
	'textFontFamilySubClassMediumItalic': 'Medelkursiv',
	'textFontFamilySubClassHeavy': 'Tjock',
	'textFontFamilySubClassHeavyItalic': 'Tjock kursiv',
	'textFontFamilySubClassDemiBold': 'Demifet',
	'textFontFamilySubClassDemiBoldItalic': 'Demifet kursiv',
	'textFontFamilySubClassBold': 'Halvfet',
	'textFontFamilySubClassBoldItalic': 'Halvfet kursiv',
	'textFontFamilySubClassExtraBold': 'Extrafet',
	'textFontFamilySubClassExtraBoldItalic': 'Extrafet kursiv',
	'textFontFamilySubClassBlack': 'Svart',
	'textFontFamilySubClassBlackItalic': 'Svart kursiv',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Automatisk teckenstorlek',
	'responsiveCoachmarkContents': 'Teckenstorleken ändras automatiskt för att passa in när du ändrar texttypen. Du kan ange teckenstorleken i textegenskaperna.',

	'propText': 'Textdetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Textegenskaper', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Teckenstorlek',
	'textFontFamily': 'Teckenfamilj',
	'textFontWeight': 'Teckengrovlek', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Bildlänk',
	'propMissingURL': 'Ange URL',
	'propImgTop': 'Bildegenskaper', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Allmänna egenskaper', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Allmänt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Allmänt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Fyllningsfärg', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Textfärg', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Kantlinjefärg',
	'propMaintainAxisScales': 'Behåll axelskala',
	'propShowItemLabel': 'Visa objektetikett',
	'propHideLegend': 'Dölj teckenförklaring',
	'propColorPalette': 'Palett',
	'propLegendPosition': 'Teckenförklaringsplacering',
	'propHideAxisTitleLabels': 'Dölj axelrubriker',
	'propLineColor': 'Linjefärg',
	'propBubbleColor': 'Bubbelfärg',
	'propInterpolation': 'Jämna linjer',
	'propElementColor': 'Visualiseringselementfärg',
	'propSymbolShape': 'Symbolform',
	'propHeatScalePalette': 'Färgordning',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Mörkare färger representerar mindre värden.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Mörkare färger representerar större värden.',
	'propImageDetails': 'Bilddetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Webbsidesdetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Mediadetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Fyll i URL-adressen och tryck på Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Position/format',
	'propPositionLabel': 'Placering', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Storlek', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Bredd',
	'propResizeHeight': 'Höjd',
	'propRotateLabel': 'Rotera',
	'propRotateAngle': 'Vinkel', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Antal ikoner',
	'propScaleDescription': 'Välj antal ikoner',
	'propScaleFew': 'Låg',
	'propScaleDefault': 'Standard',
	'propScaleMany': 'Hög',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Värdet måste vara numeriskt',

	'mediaAriaLabel': 'URL-indata',
	'dropdownAriaLabel' : 'Listruta',
	'ariaGroupLabel': 'Listrutekategori: %{cateoryLabel} objekt: %{itemLabel}. Tryck på nedtangenten för att expandera. Tryck på upp- och nedtangenten för att navigera eller tryck på Esc för att komprimera.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Uppdaterades senast: %{timeInterval} sedan',
	'widgetTimer': 'Widgettimer',

	// Theme colors
	'transparent': 'Ingen färg',
	'white': 'Vit',
	'lightGrey': 'Ljust grå',
	'grey': 'Grå',
	'darkGrey': 'Mörkt grå',
	'black': 'Svart',
	'lightBlue': 'Ljust blå',
	'blue': 'Blå',
	'darkBlue': 'Mörkt blå',
	'yellow': 'Gul',
	'orange': 'Orange',
	'lime': 'Lime',
	'green': 'Grön',
	'peach': 'Persika',
	'red': 'Röd',
	'violet': 'Violett',
	'aqua': 'Hav',
	'purple': 'Lila',
	'plum': 'Plommon',
	'gray10': 'Grå 10',
	'gray20': 'Grå 20',
	'gray30': 'Grå 30',
	'gray50': 'Grå 50',
	'gray60': 'Grå 60',
	'gray70': 'Grå 70',
	'gray80': 'Grå 80',
	'gray90': 'Grå 90',
	'gray100': 'Grå 100',
	'blue50': 'Blå 50',
	'blue60': 'Blå 60',
	'blue70': 'Blå 70',
	'green40': 'Grön 40',
	'green50': 'Grön 50',
	'red50': 'Röd 50',
	'red60': 'Röd 60',


	//Theme Palette Label
	'paletteLabel': 'IBM-palett %{number}',
	'heatPaletteLabel': 'IBM-färgpalett %{number}',
	'conditionalPaletteLabel': 'IBM-villkorspalett %{number}',
	'carbonPaletteXLight': 'Kol X ljus',
	'carbonPaletteXDark': 'Kol X mörk',
	'carbonPalettePurple': 'Lila',
	'carbonPaletteTeal': 'Blågrön',
	'carbonPaletteCyan': 'Cyan',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Lila blågrön',
	'carbonPaletteCyanMagenta': 'Cyan magenta',
	'carbonPaletteGreenRed': 'Grön röd',
	'carbonPaletteGreenYellowRed': 'Grön gul röd',
	'carbonPalettePurpleTealConvergent': 'Lila blågrön konvergent',
	'carbonPaletteCyanMagentaConvergent': 'Lila magenta konvergent',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Ljus IBM-palett',
	'userPaletteColor_defaultTheme': 'IBM-standardpalett',
	'userPaletteColor_darkTheme': 'Mörk IBM-palett',

	// Dashboard
	'propDashboardBackgroundColor': 'Bakgrundsfärg',
	'propLayoutPositioning': 'Layoutposition',
	'propLayoutRelative': 'Relativ',
	'propLayoutAbsolute': 'Absolut',
	'propLayoutPositioningCoachmarkTitle': 'Välj ett layoutformat',
	'propLayoutPositioningCoachmarkContent': 'I en relativ layout justeras widgetarnas storlek och placering efter skärmen. Widgetar i en absolut layout visas exakt som du anger dem i vyn, oavsett skärmstorlek.',
	'gridText': 'Visa rutnät',
	'snapText': 'Anpassa till rutnät',
	'snapObjectsText': 'Anpassa till objekt',
	'fitPageText': 'Anpassa till sida',
	'gridLabel': 'Rutnät',
	'heightUnit': 'h',
	'widthUnit': 'b',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Sidstorlek',
	'propPageSizePresetAriaLabel': 'Förinställningar för sidstorlek',
	'propPageSizePreset': 'Förinställd',
	'propPageSizePresetCustom': 'Anpassat',
	'propPageSizePreset16x9': 'Skärm 16:9',
	'propPageSizePreset4x3': 'Skärm 4:3',
	'propPageSizePresetInfographic': 'Infografisk',
	'propPageSizeWidth': 'Bredd',
	'propPageSizeHeight': 'Höjd',
	'propPageSizeWidthAriaLabel': 'Sidstorleksbredd',
	'propPageSizeHeightAriaLabel': 'Sidstorlekshöjd',
	'propPageSizeAdjustedMessage': 'Sidstorleken ökades efter du angav ett värde under minimivärdet eller så får sidan inte plats på kontrollpanelen.',
	'propTabShow': 'Visa flikar',
	'propShowTabsInPreview': 'Visa flikar i förhandsgranskning',
	'multilingualDashboardsLabel': 'Språk',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Standard',
	'multilingualDashboardsAddLinkText': 'Lägg till ett annat språk',
	'multilingualDashboardsSelect': 'Välj',
	'multilingualDashboardsButtonLabel': 'Lägg till',
	'multilingualDashboardTranslationMode': 'Du är i översättningsläge (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Klart',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} översättningar återstår',
	'multilingualDashboardRemainingString': '1 översättning återstår',
	'multilingualDashboardsSetDefault': 'Ange standardspråk',
	'multilingualDashboardIconMore': 'Fler åtgärder för språk %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Översättningsbart område',
	'multilingualDeleteTitle': 'Standardspråk',
	'multilingualDeleteLanguageWarning': 'Vill ta bort språket %{language}?',
	'multilingualSelectLanguage': 'Välj ett språk',
	'confirmLayoutStyleUpgradeTitle': 'Tillämpa på alla flikar',
	'confirmLayoutStyleUpgrade': 'Tillämpa det här layoutformatet på alla flikar på kontrollpanelen?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Ta bort',
	'tabDeleteDialogTitle': 'Vill du ta bort fliken?',
	'tabDeleteDialogMessage': 'Allt flikinnehåll tas också bort.',

	// Vis widget
	'propVisTypeReturn': 'Visualiseringstyper',
	'propVisDetails': 'Detaljer:',

	// Alignment picker
	'propAlignPickTop': 'Justera överst',
	'propAlignPickRight': 'Justera åt höger',
	'propAlignPickBottom': 'Justera nederst',
	'propAlignPickLeft': 'Justera åt vänster',
	'propAlignPickCenter': 'Centrera',
	'propAlignPicker': 'Justering',

	// Toolbar picker
	'propToolbarPickBold': 'Halvfet',
	'propToolbarPickUnderline': 'Understrykning',
	'propToolbarPickItalic': 'Kursiv',
	'propToolbarPickJustifyLeft': 'Justera åt vänster',
	'propToolbarPickJustifyCenter': 'Centrera',
	'propToolbarPickJustifyRight': 'Justera åt höger',
	'propToolbarPickJustify': 'Marginaljustera',

	'propList': 'Lista',
	'propOrderedList': 'Numrerad lista',
	'propUnorderedList': 'Onumrerad lista',

	// Symbol shapes
	'propCircle': 'Cirkel',
	'propTriangle': 'Triangel',
	'propSquare': 'Kvadrat',
	'propRect': 'Rektangel',
	'propStar': 'Stjärna',
	'propCross': 'Kors',
	'propPlus': 'Plus',
	'propPoly': 'Polygon',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Vänster',
	'propRight': 'Höger',
	'propTop': 'Överst',
	'propBottom': 'Nederst',

	// Interpolation options
	'propSmooth': 'Jämn',
	'propStraight': 'Rak',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Lista', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Flytta åt vänster', // screen reader
	'srWidgetMoveUp': 'Flytta upp', // screen reader
	'srWidgetMoveRight': 'Flytta åt höger', // screen reader
	'srWidgetMoveDown': 'Flytta ned', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Öka storleken proportionellt', // screen reader
	'srWidgetResizeSmaller': 'Minska storleken proportionellt', // screen reader
	'srWidgetResizeBiggerV': 'Öka storleken vertikalt', // screen reader
	'srWidgetResizeSmallerV': 'Minska storleken vertikalt', // screen reader
	'srWidgetResizeBiggerH': 'Öka storleken horisontellt', // screen reader
	'srWidgetResizeSmallerH': 'Minska storleken horisontellt', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Rotera medurs', // screen reader
	'srWidgetRotateCCW': 'Rotera moturs', // screen reader

	// Recommended types
	'visChange': 'Ändra visualisering',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualisering',
	'chartLabel': '%{chartName}-diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Tryck på F12 för att navigera i widgeten',
	'f10KeyDescription': 'Tryck på F10 för att starta widgetfokusvyn',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} med värde %{value}',

	'shapeColorLabel': 'Formfärg',
	'showLegendLabel': 'Visa teckenförklaring',

	//Webpage
	'webpageWidgetTitle': 'Webbsideswidget',
	'webpagePasteLink': 'Klistra in URL-adressen och tryck på Enter så sparas den.',
	'propWebpageLink': 'Webbsides-URL',
	'propWebpageTitle': 'Webbsidesrubrik',
	'propWebpageTitleDescription': 'Webbsidans rubrik',
	'webpageUrl': 'Webbsides-URL',
	'noWebpageSelected': 'Ingen webbsida har valts',
	'enterWebpageUrl': 'Ange webbsides-URL här',
	'propWebpageTop': 'Webbsidesegenskaper', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Webbsides-URL saknas.',
	'webpageUrlValidationError': 'Ogiltig webbsides-URL.',
	'webpageHttpValidationError': 'Webbsidan måste accessas med hjälp av en HTTPS-länk.',
	'webpageInvalidDomainError': 'Webbsidesadressen pekar på en domän som inte har godkänts av administratören. De domäner som har godkänts av administratören är "%{domains}".',

	//VizState
	'vzErrorLoading': 'Det går inte att läsa in visualisering',
	'vzErrorLoadingMissingData': 'Det går inte att läsa in visualisering. Kontextdata saknas.',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Mediewidget',
	'mediaPasteLink': 'Klistra in URL-adressen och tryck på Enter så sparas den.',
	'mediaUrl': 'Medie-URL',
	'noMediaSelected': 'Inga media har valts',
	'enterMediaUrl': 'Ange medie-URL här',
	'videoHeight': 'Höjd:',
	'videoWidth': 'Bredd:',
	'propMediaLink': 'Medielänk',
	'propMediaTitle': 'Medierubrik',
	'propMediaTitleDescription': 'Mediets rubrik',
	'propMediaTop': 'Medieegenskaper', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Medielänk-URL saknas.',
	'mediaUrlValidationError': 'Ogiltig mediefils-URL.',
	'mediaUnknownValidationError': 'Den här medietypen hanteras inte.',
	'mediaHttpValidationError': 'Mediefilen måste accessas med hjälp av en HTTPS-länk.',
	'mediaInvalidDomainError': 'Mediefilens adress pekar på en domän som inte har godkänts av administratören. De domäner som har godkänts av administratören är "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Egenskaper', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Datamängd',
	'dataViewsLabel': 'Visa',
	'columnQuality': 'Datakvalitet',
	'columnProperties': 'Dataegenskaper',

	'dataQuality': 'Datakvalitet',
	'dataQualityRowCount': 'Antal rader',
	'dataQualityDistribution': 'Fördelning',
	'dataRowLabel': 'Data',

	// Modelling UI
	'typeColumn': 'Typ',
	'modellingColumnType': 'Typ',
	'modellingColumnAggregation': 'Aggregering',
	'modellingColumnUsage': 'Användning',
	'modellingColumnSort': 'Sortera',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Kategori',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Läser in...',

	'modellingProcessing': 'Bearbetar...',
	'modellingImport': 'Importera',
	'modellingReimport': 'Importera igen',
	'modellingDatasourceTitle': 'Datakälla',
	'modellingImportStartedTitle': 'Importen har startat',
	'modellingImportStartedText': 'Det kan ta tid att importera data. (Du kan skapa en vy under tiden data importeras.)',
	'importDatasourceTitle': 'Anslutningar',
	'dropHere': 'Dra hit för att skapa en ny datakälla...',
	'browseButton': 'Bläddra',
	'errorNoData': 'Inga data att bearbeta.',
	'errorNoFile': 'Ingen fil att överföra.',
	'errorUploadFailed': 'Det går inte att överföra.',
	'uploadSucceessful': 'Överföringen är klar',
	'del_datasourceTitle': 'Data bort datamängd',
	'del_datasourceMsg': 'Vill du ta bort \'%{name}\'?',
	'modellingFileUpdate': 'Uppdatera',
	'modellingFileUpdateTitle': 'Uppdatera datamängd',
	'modellingFileUpdateDescription': 'Vill du uppdatera \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Uppdaterar \'%{name}\'',
	'modellingUpdateStartedTitle': 'Importuppdatering startades',
	'modellingUpdateStartedText': 'Det kan ta tid att uppdatera data. (Du kan skapa en vy under tiden data uppdateras.)',
	'modellingErrorImportUploadNoFile': 'Ingen fil att överföra.',
	'modellingErrorImportUploadFailed': 'Det går inte att överföra.',
	'modellingErrorImportUploadInvalidType': 'Ogiltig filtyp.',
	'modellingErrorImportUploadTableFailed': 'Det går inte att hämta tabeller.',
	'modellingIntentResultsTitle': 'Välj föreslagen datamängd att använda',
	'modellingColumnViewRelationships': 'Visa relaterade tabeller',
	'modellingTableRelatedTables': 'Tabeller relaterade till \'%{name}\'',
	'modellingTable': '%{name} - Tabell',
	'modellingColumnIncludedInDataSet': 'Tillagd',
	'modellingDataSet': 'Datamängd',
	'modellingViewInDataSet': 'Visa i datamängd',
	'modellingViewRelatedTables': 'Visa relaterade',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Inga relaterade tabeller hittades',

	'modellingValidatingDataset': 'Validerar...',
	'datasetFinishedRefreshing': 'Datauppsättningen %{datasetName} har uppdaterats.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Lös kopplingsväg:',
	'modellingJoinColumns': 'Definiera kopplingsväg för tabell: %{name}',
	'modellingJoinToTable': 'Koppla till tabell: %{name}',

	// Data Quality
	'excluded': 'Exkluderat',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filter',
	'modellingColumnSortNone': 'Rensa sortering',
	'modellingColumnSortAsc': 'Sortera stigande',
	'modellingColumnSortDesc': 'Sortera fallande',
	'modellingColumnRemove': 'Ta bort kolumn',

	// Import File Browser
	'dropboxPageTitle': 'Ny Dropbox-anslutning',
	'sizeColumn': 'Storlek',

	//Modelling Column Property Values
	'dataType_string': 'Sträng',
	'dataType_date': 'Datum',
	'dataType_integer': 'Heltal',
	'dataType_double': 'Dubbel',
	'dataType_float': 'Flyttal',
	'dataType_boolean': 'Boolesk',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Antal',
	'defaultAggregation_countdistinct': 'Antal distinkta',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Medel',
	'defaultAggregation_sum': 'Summa',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Fakta',
	'type_attribute': 'Attribut',

	'defaultSort_none': 'Sortera inte',
	'defaultSort_asc': 'Sortera stigande',
	'defaultSort_desc': 'Sortera fallande',

	'category_none': 'Inget',
	'category_location': 'Plats',
	'category_monetary': 'Monetär',
	'category_time': 'Tid',

	// Root menu
	'rootMenuTitle': 'Huvudmeny',

	'errorMessageTitle': 'Fel',
	'errorMessageDetails': 'Detaljer: ',
	'errorMessageTitleAssetAlreadyExists': 'Resursen finns redan',

	'defaultTabTitle': 'Flik %{index}',
	'tabAddBtnTitle': 'Lägg till flik',

	'unsupportedConditionalFormattingEncountered': 'Villkorlig formatering tillämpas inte längre på vissa kolumner.',


	// Homepage View
	'nameColumn': 'Namn',
	'creatorColumn': 'Skapades av',
	'creationDateColumn': 'Skapades',
	'versionColumn': 'Version',
	'modifiedColumn': 'Ändrades senast',

	'filterBy': 'Filtrera objekt',
	'allFilter': 'Alla objekt',
	'createdByMeFilter': 'Skapades av mig',
	'sharedWithMeFilter': 'Delas med mig',
	'favoritesFilter': 'Mina favoriter',
	'recentsFilter': 'Nyligen tillagda',
	'sortBy': 'Sortera efter',

	// Sort Menu
	'sortModified': 'Ändrades',
	'sortUpdated': 'Uppdaterades',
	'sortName': 'Namn',

	'viewAs': 'Visa som',
	'thumbnailsView': 'Visa om miniatyr',
	'listView': 'Visa som lista',
	'createMenu': 'Skapa',
	'newAppItem': 'Kontrollpanel',
	'newDataSet': 'Datamängd',

	'menuSelectionState_a11y': '"%{item}"-väljare satt till "%{selectedItem}"',

	'unableToShareItem': 'Det går inte att dela objektet "%{item}".',
	'toastFetchingContent': 'Hämtar mer innehåll...',
	'unableToGetData': 'Det går inte att hämta innehåll.',
	'unableToFavorite': 'Det går inte att ändra favoritstatus.',
	'hpErrorMissingRequiredOptions': 'Obligatoriska initieringsalternativ som saknas',
	'unableToOpenBoard': 'Det går inte att öppna "%{name}".',
	'unableToDuplicateBoard': 'Det går inte att kopiera "%{name}".',
	'unableToCreateBoard': 'Det går inte att skapa "%{name}".',
	'unableToCreateBoardNameConflict': 'Det finns redan en resurs med samma namn.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Rader',
	'importWarnings': 'Varningar',
	'lineNumbers': 'Rader',
	'excerptFromSource': 'Utdrag',
	'reason': 'Orsak',
	'numberOfRowsDropped': 'borttagna rader',
	'oneRowDropped': '1 rad togs bort',

	// Type Menu
	'typeMenuLabel': 'Typ',
	'dashboardsLabel': 'Kontrollpaneler',
	'datasetsLabel': 'Datamängder',
	'storiesLabel': 'Berättelser',
	'allLabel': 'Alla typer',

	// Board Page View App Bar
	'datasets': 'Datamängder',
	'settings': 'Egenskaper',
	'add': 'Lägg till',
	'widgets': 'Widgetar',
	'dashboardProperties': 'Kontrollpanelegenskaper',
	'searchPanel' : 'Sök',
	'pins': 'Samling',
	'pinsOld': 'Mina uppsatta objekt',
	'pinsDateFilterHeading' : 'Uppsatt datum',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} uppsatt objekt |||| %{smart_count} uppsatta objekt',
	'pinSearch': 'Sök',
	'pinSearchOld': 'Sök efter uppsatta objekt',
	'pinListView': 'Lista',
	'pinIconView': 'Ikoner',
	'pinRemove': 'Ta bort',
	'pinCreate': 'Skapa',
	'pinDeleteError': 'Det går inte att ta bort ett eller fler objekt från samlingen. Försök igen senare.',
	'pinDeleteErrorOld': 'Det går inte att ta bort ett eller fler uppsatta objekt. Försök igen senare.',
	'pinRetrieveError': 'Det går inte att hämta ett eller fler uppsatta objekt. Försök igen senare.',
	'NoPinsCollected': 'Inga favoritvisualiseringar',
	'pinDeletedToast': 'Favoriten togs bort',
	'pinAddedToast': 'Favoriten lades till i Mina favoriter',
	'pinningToast': 'Bearbetar pin...',
	'pinDateFilter': 'Datumfilter',
	'pinDateFilterAll': 'Alla',
	'pinDateFilterToday': 'I dag',
	'pinDateFilterYesterday': 'I går',
	'pinDateFilterPastWeek': 'Förra veckan',
	'pinDateFilterPastMonth': 'Förra månaden',
	'pinDateFilterEarlier': 'Tidigare',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Ändra rubrik',
	'toolbarActionSort': 'Sortera',
	'toolbarActionSortAscending': 'Sortera stigande',
	'toolbarActionSortDescending': 'Sortera fallande',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Formatdata',
	'toolbarActionFormatAbbreviation': 'Avrunda',
	'toolbarActionFormatNone': 'Auto',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Högsta eller lägsta',
	'toolbarActionAddShape': 'Lägg till form',
	'toolbarActionRmvShape': 'Ta bort form',
	'toolbarActionToggleShapeDrop': 'Infografikform',
	'toolbarActionToggleShapeDropTitle': 'Skapa en infografik',
	'toolbarActionToggleShapeDropText': 'Dra en form till det här fältet för att skapa en infografik.',
	'toolbarActionAggregationType': 'Summera',
	'toolbarDeleteActionText': 'Ta bort kolumn',
	'toolbarActionFilterLocalKeepSelected': 'Behåll',
	'toolbarActionFilterLocalExcludeSelected': 'Exkludera',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Enkel beräkning',
	'toolbarActionDrillBack': 'Föregående',
	'toolbarActionDrillUp': 'Borra uppåt',
	'toolbarActionDrillDown': 'Borra nedåt',
	'toolbarActionNavigate': 'Bläddra',
	'toolbarActionCreateFilterGroup': 'Skapa ny anslutning',
	'toolbarActionDisconnectFilterGroup': 'Bryt alla länkar',
	'toolbarActionLinkFilterGroup': 'Lägg till en befintlig anslutning',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Lägg till',
	'sidebarMultiselect': 'Växla flerval',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} valda',

	'multiselectWithTotalMsg': '%{count} av %{total}',
	'sidebarGoBack': 'Gå tillbaka',

	//DataSet pane
	'errorLoadingDataSets': 'Det går inte att läsa in datamängd',
	'errorLoadingDataSetMetaData': 'Det går inte att läsa in datamängd',
	'dataSetPaneLastUpdated': 'Uppdaterades senast: %{date}',
	'dataSetPaneDateUnknown': 'Okänt',
	'sourcePaneLabel': 'Valda källor',
	'addSourceLabel': 'Lägg till källa',
	'find_label': 'Sök',
	'navigationPathsLabel': 'Navigeringsvägar',

	//widgetlist
	'errorLoadingWidgetList': 'Det går inte att läsa in objekten.',
	'errorLoadingThemeFile': 'Det går inte att läsa in temadefinitionen.',
	'errorLoadingLayoutFile': 'Det går inte att läsa in vyn.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Det går inte att läsa in tillgängliga visualiseringsdefinitioner',

	'dwErrorLoadingVisualizationNotFound': 'Det går inte att läsa in objektet eftersom visualiseringsdefinition saknas.',
	'dwErrorLoadingVisualizationListNotFound': 'Det går inte att läsa in visualiseringen.',
	'dwErrorRunningQuery': 'Det går inte att hämta data från datamängden %{datasetName}.',
	'dwErrorGeoData': 'Det går inte att visa geografiska data på en karta. Välj en annan visualiseringstyp. ',
	'dwPromptSignonCancelWarning': 'Data för den här visualiseringen är inte tillgängliga. Fyll i korrekta kreditiv.',
	'dwErrorMissingDataset': 'Det går inte att läsa in visualiseringen eftersom den associerade datamängden \'%{datasetName}\' inte är tillgänglig.',
	'dwErrorRenderingVisualization': 'Det går inte att läsa in visualiseringen.',
	'dwErrorVisualizationTooSmall': 'Visualiseringen är för liten för att visa alla data. Gör visualiseringen större än begränsa datamängden.',
	'aria_label_datatable': 'Datatabell',
	'aria_key_navi_datatable_desc': 'Använd piltangenterna för att navigera till cellerna. Tryck på Ctrl och Home för att flytta till första raden, Ctrl och End för att flytta till sista raden.',
	'geomapUnrecognizedLocations': 'Okända platser:',
	'geomapAmbiguousLocations': 'Tvetydiga regioner:',

	// custom widget
	'customWidget': 'Anpassad widget',
	'customWidgetsTitle': 'Anpassade widgetar',
	'noCustomWidgets': 'Inga anpassade widgetar',

	// Action names
	'toggleContextBar': 'Växla kontextfält',
	'delete': 'Ta bort',
	'share': 'Dela',
	'unshare': 'Sluta dela',
	'rename': 'Byt namn',
	'close': 'Stäng',
	'duplicate': 'Kopiera',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Försök igen',

	'changeTemplate': 'Byt mall',

	// Aggregation Types
	'sum': 'Summa',
	'count': 'Antal',
	'countdistinct': 'Antal distinkta',
	'avg': 'Medel',
	'min': 'Minimum',
	'max': 'Maximum',
	'custom': 'Anpassat',
	'calculated': 'Beräknat',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% ändring',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Visualiseringskriterier...',
	'QuickAddResultsHeader': 'Datavisualiseringar',
	'NoQuickAddResults': 'Inga träffar. Vill du skapa en ny datamängd?',
	'NoQuickAddResultsRetry': 'Det går inte att hitta några träffar. Försök igen med andra sökvillkor.',
	'templateWidgetTitle': 'Mall',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(tom)',

	'nullValueContent': '(inget värde)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Textfilter - %{columnName}',

	'textFilterSelectTab': 'Välj',

	'textFilterConditionTab': 'Ange villkor',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Det finns inga tillgängliga objekt.',

	'textFilterEquals': 'Lika med',
	'textFilterContains': 'Innehåller',
	'textFilterBeginsWith': 'Börjar med',
	'textFilterEndsWith': 'Slutar med',
	'textFilterDoesNotEqual': 'Är inte lika med',
	'textFilterDoesNotContain': 'Innehåller inte',
	'textFilterDoesNotBeginWith': 'Börjar inte med',
	'textFilterDoesNotEndWith': 'Slutar inte med',
	'textFilterSampleText': 'Exempel: A',

	'textFilterAndButton': 'Och',
	'textFilterOrButton': 'Eller',

	'dateFilterMessage': 'Välj ett datumintervall',
	'dateRangeControlRegionLabel': 'Datumintervallfilter - %{columnName}',
	'dateFilterRangeOption': 'Intervallalternativ',
	'dateFilterDateLabel': 'Datum',
	'dateFilterBlank': '(tom)',
	'dateFilterBefore': 'Före',
	'dateFilterAfter': 'Efter',
	'dateFilterBetween': 'Mellan',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'Datum',
	'dateIncludeBlankLabel': 'Inkludera tomt datum',

	'timeTitle': 'Tid',
	'timeFilterMessage': 'Välj ett tidsintervall',
	'dateTimeFilterMessage': 'Välj ett intervall av datum och tid',

	'topbottomNumberOfResultsLabel': 'Antal resultat',
	'topbottomPercentLabel': 'Procent',
	'topbottomNumberOfResultsLimit': 'Mellan %{lower}-%{higher}',
	'topbottomSelectOption': 'Alternativ för högsta eller lägsta',
	'topbottomOptionLabel': 'Visa',
	'searchByLabel': 'Efter',
	'searchNoMatches': 'Inga träffar hittades',
	'topbottomRankColumnLabel': 'Lägg till rangordningskolumn i tabellen',
	'topbottomNone': 'Inget',
	'topCount': 'Antal högsta',
	'topPercent': 'Högsta %',
	'bottomCount': 'Antal lägsta',
	'bottomPercent': 'Lägsta %',
	'topbottomSearchColumn': 'Sök en kolumn',
	'searchColumnAriaLabel': 'Sök en kolumn. Skriv namnet på kolumnen du vill söka efter och klicka på nedåtpilen för att söka efter kolumnen i listan.',
	'rankColumnLabel': 'Rangordna (%{columnLabel})',
	'topbottomClearLabel': 'Rensa',

	'rangeFilterControlRegionLabel': 'Intervallfilter - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Skjutreglage - använd höger- och vänsterpilarna för att flytta skjutreglagehandtagen',
	'sliderHandleLabel': 'Skjutreglagehandtag',
	'a11ySliderHandleLabel': 'Skjutreglagehandtag %{sliderValue}',
	'sliderInputLabel': 'värde',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Vissa datamängdsobjekt som används i visualiseringen är inte tillgängliga.',
	'datasetItemUnavailable': 'Det här datamängdsobjektet är inte tillgängligt',

	//Authoring topBottom
	'topOperator': 'Överst',
	'bottomOperator': 'Nederst',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} av %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Endast detta objekt',
	'deleteTopBottom': 'Ta bort antal högsta och lägsta',
	'editTopBottom': 'Ändra antal högsta och lägsta',
	'deleteDrillState': 'Ta bort aktuellt borrningsläge',
	'ariaDeleteDrillStateLabel': 'Tryck på Enter om du vill ändra antalet för högsta och lägsta.',
	'drillUpStateTitle': 'Borra uppåt',
	'drillDownStateTitle': 'Borra nedåt',
	'ariaEditTopBottomLabel': 'Tryck på Enter om du vill ändra antalet för högsta och lägsta.',
	'ariaDeleteTopBottomLabel': 'Tryck på Delete om du vill ta bort antalet för högsta och lägsta.',

	// Authoring filtering
	'dimFilterIn': 'Inkluderar: %{in}',
	'dimFilterNotIn': 'Exkluderar: %{out}',
	'measureFilterBetween': 'Mellan %{lowerBound} och %{upperBound}',
	'measureFilterNotBetween': 'Inte mellan %{lowerBound} och %{upperBound}',
	'gtFilter': 'Efter %{lowerBound}',
	'ltFilter': 'Före %{upperBound}',
	'notGtFilter': 'Inte efter %{lowerBound}',
	'notLtFilter': 'Inte före %{upperBound}',
	'localFilterTitle': 'Endast detta objekt',
	'globalFilterTitle': 'Alla objekt',
	'deleteFilter': 'Ta bort filter',
	'editFilter': 'Ändra filter',
	'ariaEditFilterLabel': 'Tryck på Enter för att ändra filtret.',
	'ariaDeleteFilterLabel': 'Tryck på Delete för att ta bort filtret.',

	// Prompts
	'ariaEditPrompt': 'Tryck på Enter för att ändra promptvärdet',

	'moreDataIndicator': 'Data klipptes av vid %{threshold} objekt. Tillämpa ett filter för att visa färre.',

	// data point filtering
	'dataPointFilterTitle': 'Datapunkter',
	'dataPointFilterIncludeSummary': '%{valueCount} datapunkter inkluderades',
	'dataPointFilterExcludeSummary': '%{valueCount} datapunkter exkluderades',

	// DB2 connection page
	'db2Database': 'DB2-databas (%{jdbcConnection})',
	'db2Title': 'Anslut till IBM DB2',

	// Database
	'databaseConnectionMessage': 'Fyll i databasanslutningsdetaljer:',
	'connectionString': 'Databasanslutningssträng',
	'databaseCredentials': 'Kreditiv: ',
	'databaseUserName': 'Användarnamn',
	'databasePassword': 'Lösenord',
	'databaseConnect': 'Anslut',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Ange en sökterm:',
	'twitterKeyword': 'Nyckelord',
	'twitterSearch': 'Sök',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Det går inte att skapa vyn: %{error} Misslyckad åtgärd: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Widgetfilter',
	'missingColumn': 'Saknas: %{columnLabel}',
	'missingFiltering': 'Filter saknas för följande kolumn-ID:',
	'heatByLabel': 'Värme efter',
	'evColumns': 'Kolumner',
	'evLocalFilters': 'Lokala filter',
	'evExpand': 'Expandera',
	'evFilterTooltip': 'Filter',
	'evAdd': 'Lägg till kolumn',

	// Navigation View
	'navigationBack': 'Föregående',

	// Pinning
	'contentPinFail': 'Det går inte att samla in innehållet. Försök igen senare.',
	'contentPinFailOld': 'Det går inte att sätta upp innehållet. Försök igen senare.',

	// Layouts
	'dropZoneLabel': 'Dra hit för att maximera',

	//Share
	'shareDefaultPageTitle': 'Sida %{index}',

	'nextPage': 'Nästa sida',
	'previousPage': 'Föregående sida',

	'assetAssembly': 'Vy',

	'toolbar_save': 'Spara',
	'brgr_saveAs': 'Spara som',
	'brgr_refresh': 'Uppdatera',

	// Save
	'saving': 'Sparar...',
	'save_success': 'Vyn har sparats.',
	'save_failure': 'Tyvärr. Det gick inte att spara vyn. Försök igen senare.',
	'dashboard_save_success': 'Kontrollpanelen har sparats.',

	'geminiLeave': 'Du lämnar IBM Watson Analytics.',

	'warning': 'Varning',
	'missingDataSetData': 'Data för den här datamängden är inte tillgängliga. Uppdatera datamängden eller be administratören om åtkomst till källan.',

	// Calculations
	'error_calculation_in_use': 'Vald beräkning används och kan inte tas bort.',

	'resize': 'Ändra storlek',
	'rotate': 'Rotera',
	'moveHandle': 'Flytta widget',
	'expandHandle': 'Expandera',
	'panHandle': 'Panorera',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navigera till',

	// Slide out titles
	'shapeSlideoutTitle': 'Former',
	'textSlideoutTitle': 'Text',
	'mediaSlideoutTitle': 'Media',
	'visualizationSlideoutTitle': 'Visualiseringar',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Ogiltig JSON. Det finns mer information i felloggen',

	// Widget type labels
	'shape_label': 'Form',
	'image_label': 'Bild',
	'data_label': 'Diagram',
	'media_label': 'Media',
	'text_label': 'Text',
	'embedMedia_label': 'Media',
	'youtube_label': 'YouTube-video',
	'webpage_label': 'Webbsida',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Form',
	'noExtraText_shape_numbered': 'Form (%{number})',
	'few_shape': 'Grupp av %{count} former',
	'many_shape': 'Grupp av %{count} former',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} bild',
	'one_image_numbered': '%{text} bild (%{number})',
	'noExtraText_image': 'Bild',
	'noExtraText_image_numbered': 'Bild (%{number})',
	'few_image': 'Grupp av %{count} bilder',
	'many_image': 'Grupp av %{count} bilder',
	'noExtraText_text': 'Tom textruta',
	'noExtraText_text_numbered': 'Tom textruta (%{number})',
	'few_text': 'Grupp av %{count} textrutor',
	'many_text': 'Grupp av %{count} textrutor',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube viewer',
	'pacubeviewer_named': '%{name} Cube viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} gånger %{row_level1} och %{column_level1} korstabell',
	'crosstab_opt_mapping_numbered': '%{values} gånger %{row_level1} och %{column_level1} korstabell (%{number})',
	'crosstab_has_mapping': '%{values} gånger %{row_level1} korstabell',
	'crosstab_has_mapping_numbered': '%{values} gånger %{row_level1} (%{number}) korstabell',
	'crosstab_no_mapping': 'Tom korstabell',
	'crosstab_no_mapping_numbered': 'Tom korstabell (%{number})',
	'crosstab_named': '%{name} korstabell',
	'crosstab_named_numbered': '%{name} korstabell (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} tabell',
	'JQGrid_has_mapping_numbered': '%{grid_cols} tabell (%{number})',
	'JQGrid_no_mapping': 'Tom tabell',
	'JQGrid_no_mapping_numbered': 'Tom tabell (%{number})',
	'JQGrid_named': '%{name} tabell',
	'JQGrid_named_numbered': '%{name} tabell (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} hierarki',
	'hierarchy_has_mapping_numbered': '%{level1} hierarki (%{number})',
	'hierarchy_no_mapping': 'Tom hierarki',
	'hierarchy_no_mapping_numbered': 'Tom hierarki (%{number})',
	'hierarchy_named': '%{name} hierarki',
	'hierarchy_named_numbered': '%{name} hierarki (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} karta',
	'map_has_mapping_numbered': '%{categories} karta (%{number})',
	'map_no_mapping': 'Tom karta',
	'map_no_mapping_numbered': 'Tom karta (%{number})',
	'map_named': '%{name} karta',
	'map_named_numbered': '%{name} karta (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} summavärde',
	'summary_has_mapping_numbered': '%{actual} summavärde (%{number})',
	'summary_no_mapping': 'Tomt summavärde',
	'summary_no_mapping_numbered': 'Tomt summavärde (%{number})',
	'summary_named': '%{name} summavärde',
	'summary_named_numbered': '%{name} summavärde (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} gånger %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} gånger %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'Tomt KPI',
	'kpi_no_mapping_numbered': 'Tomt KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infografik',
	'infographicSummary_has_mapping_numbered': '%{actual} infografik (%{number})',
	'infographicSummary_no_mapping': 'Tom infografik',
	'infographicSummary_no_mapping_numbered': 'Tom infografik (%{number})',
	'infographicSummary_named': '%{name} infografik',
	'infographicSummary_named_numbered': '%{name} infografik (%{number})',
	'noExtraText_youtube': 'YouTube-video',
	'noExtraText_youtube_numbered': 'YouTube-video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube-video',
	'one_youtube_numbered': '%{text} YouTube-video (%{number})',
	'few_youtube': 'Grupp av %{count} YouTube-videor',
	'many_youtube': 'Grupp av %{count} YouTube-videor',
	'noExtraText_embedMedia': 'Medielänk',
	'noExtraText_embedMedia_numbered': 'Medielänk (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} medielänk',
	'one_embedMedia_numbered': '%{text} medielänk (%{number})',
	'few_embedMedia': 'Grupp av %{count} medielänkar',
	'many_embedMedia': 'Grupp av %{count} medielänkar',
	'noExtraText_media': 'Media',
	'noExtraText_media_numbered': 'Media (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} media',
	'one_media_numbered': '%{text} media (%{number})',
	'few_media': 'Grupp av %{count} media',
	'many_media': 'Grupp av %{count} media',
	'noExtraText_webpage': 'Webbsida',
	'noExtraText_webpage_numbered': 'Webbsida (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} webbsida',
	'one_webpage_numbered': '%{text} webbsida (%{number})',
	'few_webpage': 'Grupp av %{count} webbsidor',
	'many_webpage': 'Grupp av %{count} webbsidor',
	'one_unknown': 'Ett objekt',
	'one_unknown_numbered': 'Ett objekt (%{number})',
	'few_unknown': 'Grupp av %{count} objekt',
	'many_unknown': 'Grupp av %{count} objekt',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Nästa',
	'previous': 'Föregående',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Aktuell navigeringsgrupp är %{navigation_group_name}',

	//Page Context
	'filterBlank': '(tom)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Filtervärden kan inte läsas in',
	'editTimelineHighlight': 'Ändra markering',

	'filterDockChevronLeft': 'Bläddra genom data',
	'filterDockChevronRight': 'Bläddra genom data',
	'expand': 'Expandera',
	'collapse': 'Komprimera',

	//Reset Dashboard
	'dashboardResetTitle': 'Återställ kontrollpanel',
	'dashboardResetMessage': 'Vill du återställa alla ändringar som tillämpats på kontrollpanelen?',
	'dashboardResetToast': 'Kontrollpanelen har återställts.',

	//Generate PDF
	'buildingPDF': 'Bygger PDF...',
	'exportPDF': 'Exportera till PDF',
	'pageSize': 'Sidstorlek',
	'orientation': 'Riktning',
	'filtersPresentPDF': 'Filter som används för visualiseringar på den föregående sidan:',
	'errorPDF': 'Det går inte att generera PDF. Uppdatera och försök igen.',
	'printPDFInfo': 'Visa dokumentation',
	'pdfWidget': 'Widget',
	'includeFilters': 'Visa filterdetaljer',
	'portrait': 'Stående',
	'landscape': 'Liggande',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Kontrollpanelen har uppgraderats. Spara nu för optimala prestanda.',

	'ariaFullScreenMessage': 'Tryck på Esc för att avsluta helskärmsläge',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} packat hierarkibubbeldiagram',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} packat hierarkibubbeldiagram (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Tomt packat hierarkibubbeldiagram',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Tomt packat hierarkibubbeldiagram (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} packat hierarkibubbeldiagram',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} packat hierarkibubbeldiagram (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} gånger %{values} marimekko-diagram',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} gånger %{values} marimekko-diagram (%{number})',
	'LIVE_marimekko_no_mapping': 'Tomt Marimekko-diagram',
	'LIVE_marimekko_no_mapping_numbered': 'Tomt marimekko-diagram (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko-diagram',
	'LIVE_marimekko_numbered': '%{name} marimekko-diagram (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} soldiagram',
	'LIVE_sunburst_has_mapping_numbered': '%{values} soldiagram (%{number})',
	'LIVE_sunburst_no_mapping': 'Tomt soldiagram',
	'LIVE_sunburst_no_mapping_numbered': 'Tomt soldiagram (%{number})',
	'LIVE_sunburst_named': '%{name} soldiagram',
	'LIVE_sunburst_named_numbered': '%{name} soldiagram (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} styrfunktionsanalysdiagram',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} styrfunktionsanalysdiagram (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Tomt styrfunktionsanalysdiagram',
	'LIVE_decision_analysis_no_mapping_numbered': 'Tomt styrfunktionsanalysdiagram (%{number})',
	'LIVE_decision_analysis_named': '%{name} styrfunktionsanalysdiagram',
	'LIVE_decision_analysis_named_numbered': '%{name} styrfunktionsanalysdiagram (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} linje- och stapeldiagram efter %{columnValue} och %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} linje- och stapeldiagram efter %{columnValue} och %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} linje- och stapeldiagram efter %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': '%{categories} linje- och stapeldiagram efter %{columnValue} och %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Tomt linje- och stapeldiagram',
	'LIVE_line_column_no_mapping_numbered': 'Tomt linje- och stapeldiagram (%{number})',
	'LIVE_line_column_named': '%{name} linje- och stapeldiagram',
	'LIVE_line_column_named_numbered' : '%{name} linje- och stapeldiagram (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Bubbeldiagram, %{x} gånger %{y} och %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': 'Bubbeldiagram, %{x} gånger {y} och %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Tomt bubbeldiagram',
	'LIVE_bubble_chart_no_mapping_numbered': 'Tomt bubbeldiagram (%{number})',
	'LIVE_bubble_chart_named': '%{name} bubbeldiagram',
	'LIVE_bubble_chart_named_numbered': '%{name} bubbeldiagram (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} punktdiagram',
	'LIVE_bullet_has_mapping_numbered': '%{actual} punktdiagram (%{number})',
	'LIVE_bullet_no_mapping': 'Tomt punktdiagram',
	'LIVE_bullet_no_mapping_numbered': 'Tomt punktdiagram (%{number})',
	'LIVE_bullet_named': '%{name} punktdiagram',
	'LIVE_bullet_named_numbered': '%{name} punktdiagram (%{number})',

	// powered by feature
	'ibmDb2': 'IBM DB2',
	'dashboardPoweredByPrefix': 'Data i denna dashboard tillhandahålls av',
	'showFooterToggleButtonText': 'Visa sidfot',
	'showFooterSectionText': 'Sidfot'
});
